// extracted by mini-css-extract-plugin
export default {"TabPadding":"TabPanel_TabPadding__YA7K0"};